import {parseDateFormat} from "@Common/utils/date/parse-date-format";

export const parseDate = (str):any => parseDateFormat("yyyy-mm-dd").parseDate(str);

